// John Eldhose 20180511
import { postAcademy } from '../components/home/academy/lib';
const UpdateDetails = (details) => {
  postAcademy(
    'user',
    { action: 'post', 'details': JSON.stringify(details) }, (res) => { }
  );
}
const Academy = (
  state = {page: 'Academy Home', parms: {}, user: {details: {favorites:[]}}},
  action
) => {
  var newState = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case 'ACADEMY_PAGE':
      newState.page = action.page;
      newState.parms = action.parms;
      if(['Courses', 'Learning Paths'].includes(action.page)) {
        newState.user.details.progress = {
          page: action.page, parms: action.parms
        };
        UpdateDetails(newState.user.details);
      }
      return newState;
    case 'ACADEMY_USER':
      if(action.prop === 'init') {
        newState.user = action.data;
        newState.user.details.usage.push({
          act: 'loading', ts: Math.round(Date.now() / 1000)
        });
      }
      else {
        if(action.prop === 'favorite') {
          if(newState.user.details.favorites.includes(action.data)) {
            newState.user.details.favorites = [];
            state.user.details.favorites.map((id) => {
              if(id !== action.data)
                newState.user.details.favorites.push(id);
              return true;
            })
          }
          else
            newState.user.details.favorites.push(action.data);
        }
        else if(action.prop === 'module') {
          newState.user.details.modules.push(action.data);
          newState.user.details.usage.push({
            act: 'module', ts: Math.round(Date.now() / 1000), id: action.data
          });
        }
        else if(action.prop === 'course') {
          newState.user.details.courses.push(action.data);
          newState.user.details.usage.push({
            act: 'course', ts: Math.round(Date.now() / 1000), id: action.data
          });
        }
        else if(action.prop === 'learningpath') {
          newState.user.details.learningpaths.push(action.data);
          newState.user.details.usage.push({
            act: 'learningpath', ts: Math.round(Date.now() / 1000), id: action.data
          });
        }
        UpdateDetails(newState.user.details);
      }
      return newState;
    default:
  }
  return state;
};

export default Academy;



// WEBPACK FOOTER //
// ./src/reducers/Academy.js